import { IWorkplaceData, Workplace } from './Workplace'

export type IContactData = {
    Email: string
    ErTelefonerHemmelige: boolean
    KontaktoplysningerType: string
    Telefon: string
    TelefonVis: string
    Mobil: string
    MobilVis: string
    KontaktoplysningerForArbejdssted: IWorkplaceData
}

export class Contact {
    id = 0

    name = ''

    email = ''

    telephone = ''

    telephoneShow = ''

    mobile = ''

    mobileShow = ''

    isTelefonPrivate = false

    contactInfoType = ''

    numbers: number[] = []

    // Should refactor Workplace to get only Workplace's contact?
    workPlacesContact: Workplace | undefined = undefined

    static build(data: IContactData): Contact {
        const contact = new Contact()

        contact.email = data.Email
        contact.isTelefonPrivate = data.ErTelefonerHemmelige
        contact.contactInfoType = data.KontaktoplysningerType
        contact.telephone = data.Telefon
        contact.telephoneShow = data.TelefonVis
        contact.mobile = data.Mobil
        contact.mobileShow = data.MobilVis
        contact.workPlacesContact = data.KontaktoplysningerForArbejdssted
            ? Workplace.build(data.KontaktoplysningerForArbejdssted)
            : undefined

        return contact
    }
}

export function mapContacts(data: IContactData[]): Contact[] {
    return data.map((contact) => Contact.build(contact))
}
